/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents an available insured for group selection
 * @export
 * @interface AvailableInsuredDto
 */
export interface AvailableInsuredDto {
    /**
     * 
     * @type {string}
     * @memberof AvailableInsuredDto
     */
    borrowerId: string;
    /**
     * Last name of the insured
     * @type {string}
     * @memberof AvailableInsuredDto
     */
    name: string;
    /**
     * First name of the insured
     * @type {string}
     * @memberof AvailableInsuredDto
     */
    firstName: string;
    /**
     * Individual price of this insured (without group discount)
     * @type {number}
     * @memberof AvailableInsuredDto
     */
    individualPrice: number;
    /**
     * Group price if selected with the current insured
     * @type {number}
     * @memberof AvailableInsuredDto
     */
    groupPrice: number;
    /**
     * Discount in euros
     * @type {number}
     * @memberof AvailableInsuredDto
     */
    discount: number;
    /**
     * Discount percentage
     * @type {number}
     * @memberof AvailableInsuredDto
     */
    discountPercentage: number;
}

/**
 * Check if a given object implements the AvailableInsuredDto interface.
 */
export function instanceOfAvailableInsuredDto(value: object): value is AvailableInsuredDto {
    if (!('borrowerId' in value) || value['borrowerId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('individualPrice' in value) || value['individualPrice'] === undefined) return false;
    if (!('groupPrice' in value) || value['groupPrice'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountPercentage' in value) || value['discountPercentage'] === undefined) return false;
    return true;
}

export function AvailableInsuredDtoFromJSON(json: any): AvailableInsuredDto {
    return AvailableInsuredDtoFromJSONTyped(json, false);
}

export function AvailableInsuredDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableInsuredDto {
    if (json == null) {
        return json;
    }
    return {
        
        'borrowerId': json['borrowerId'],
        'name': json['name'],
        'firstName': json['firstName'],
        'individualPrice': json['individualPrice'],
        'groupPrice': json['groupPrice'],
        'discount': json['discount'],
        'discountPercentage': json['discountPercentage'],
    };
}

export function AvailableInsuredDtoToJSON(json: any): AvailableInsuredDto {
    return AvailableInsuredDtoToJSONTyped(json, false);
}

export function AvailableInsuredDtoToJSONTyped(value?: AvailableInsuredDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'borrowerId': value['borrowerId'],
        'name': value['name'],
        'firstName': value['firstName'],
        'individualPrice': value['individualPrice'],
        'groupPrice': value['groupPrice'],
        'discount': value['discount'],
        'discountPercentage': value['discountPercentage'],
    };
}

